"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var LazyResourceLoader = /** @class */ (function () {
    function LazyResourceLoader() {
    }
    LazyResourceLoader.loadScript = function (url, async) {
        if (async === void 0) { async = true; }
        return new Promise(function (resolve, reject) {
            var script = document.createElement('script');
            script.type = 'text/javascript';
            script.async = async;
            script.onload = function () { return resolve(); };
            script.onerror = function () { return reject(); };
            script.src = url;
            script.crossOrigin = 'anonymous';
            LazyResourceLoader._appendChild(script);
        });
    };
    LazyResourceLoader.loadCss = function (href) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var link = document.createElement('link');
            // Android 4 doesn't support onload
            var onloadSupported = 'onload' in link;
            link.rel = 'stylesheet';
            link.type = 'text/css';
            link.href = href;
            link.onload = function () { return resolve(); };
            link.onerror = function () { return reject(); };
            LazyResourceLoader._appendChild(link);
            if (_this.isLegacyAndroidBrowser || !onloadSupported) {
                resolve();
            }
        });
    };
    LazyResourceLoader._appendChild = function (child) {
        document.getElementsByTagName('head')[0].appendChild(child);
    };
    LazyResourceLoader.userAgent = navigator.userAgent;
    LazyResourceLoader.isChromeBrowser = /CriOS|Chrome/.test(LazyResourceLoader.userAgent);
    /* Android 4 or below stock browsers */
    LazyResourceLoader.isLegacyAndroidBrowser = /Mozilla\/5.0/.test(LazyResourceLoader.userAgent)
        && /Android [0-4]/.test(LazyResourceLoader.userAgent)
        && /AppleWebKit/.test(LazyResourceLoader.userAgent)
        && !LazyResourceLoader.isChromeBrowser;
    return LazyResourceLoader;
}());
exports.LazyResourceLoader = LazyResourceLoader;
//# sourceMappingURL=LazyResourceLoader.js.map